import Lottie from "lottie-react";
import { useMemo } from "react";

import v1 from "../assets/loaders/v1.json";
import v2 from "../assets/loaders/v2.json";

const Loader = () => {
  const animationData = useMemo(() => (Math.random() > 0.5 ? v1 : v2), []);

  return (
    <Lottie
      animationData={animationData}
      loop={true}
      style={{
        width: "80px",
        height: "80px",
      }}
      className="**:fill-base-brand-2"
    />
  );
};

export default Loader;
